import { useMemo } from 'react';
import {
  CreateBase,
  DateInput,
  ReferenceInput,
  required,
  ResourceContextProvider,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  useGetOne,
  useNotify,
  useRefresh,
} from 'react-admin';
import { QuickbooksPriceInput } from '../components/QuickbooksPriceInput';
import { Contract } from '../types';
import { ClientSelectList } from './ClientSelectList';

export const PaymentCreate = ({
  setOpen,
  contract,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  contract: Contract;
}) => {
  const defaultPaymentDate = useMemo(
    () => new Date().toISOString().split('T')[0],
    []
  );
  
  return (
    <ResourceContextProvider value="payments">
      <CreateBase>
        <SimpleForm
          defaultValues={{ contract_id: contract?.id }}
          toolbar={
            <Toolbar>
              <DialogSaveButton setOpen={setOpen} />
            </Toolbar>
          }
        >
          <TextInput
            source="contract_id"
            type="hidden"
            label={false}
            sx={{ display: 'none' }}
          />

          <ClientSelectList contract={contract}/>

          <ReferenceInput
            source="PaymentMethodRef.value"
            reference="paymentmethods"
          >
            <SelectInput
              optionText="Name"
              label="resources.payments.fields.method"
              validate={[required()]}
            />
          </ReferenceInput>
          <QuickbooksPriceInput
            label="resources.payments.fields.amount"
            source="TotalAmt"
            validate={[required()]}
          />
          <DateInput
            source="TxnDate"
            label="resources.payments.fields.payment_date"
            defaultValue={defaultPaymentDate}
            parse={(value) => new Date(value).toISOString().split('T')[0]}
            validate={[required()]}
          />
          <TextInput
            source="PaymentRefNum"
            label="resources.payments.fields.reference"
          />
          <TextInput
            multiline
            source="PrivateNote"
            label="resources.payments.fields.note"
          />
        </SimpleForm>
      </CreateBase>
    </ResourceContextProvider>
  );
};
const DialogSaveButton = ({
  setOpen,
}: {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const notify = useNotify();
  const refresh = useRefresh();
  return (
    <SaveButton
      mutationOptions={{
        onSuccess: () => {
          notify('resources.payments.created');
          refresh();
          setOpen(false);
        },
      }}
      type="button"
    />
  );
};
